var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 40,
    viewBox: "0 0 187 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1834 0H57.4336H56.8996L40.0967 39.1502H46.3851L60.3108 6.7005L74.2365 39.1502H80.5249L63.722 0H63.1834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 39.1502L170.198 0H169.659H163.909H163.375L146.572 39.1502H152.861L166.786 6.7005L180.712 39.1502H187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1409 32.4497L77.2106 0H70.9268L87.725 39.1502H88.2636H94.0135H94.5521L111.355 0H105.067L91.1409 32.4497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84 0L135.914 32.4497L121.989 0H115.7L132.503 39.1502H133.042H138.791H139.326L156.128 0H149.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20246 0H4.01888C1.79931 0 0 2.42045 0 5.40623V12.3792C0 15.365 1.79931 17.7854 4.01888 17.7854H9.20246C11.422 17.7854 13.2213 15.365 13.2213 12.3792V5.40623C13.2213 2.42045 11.422 0 9.20246 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20246 21.3647H4.01888C1.79931 21.3647 0 23.7852 0 26.771V33.744C0 36.7297 1.79931 39.1502 4.01888 39.1502H9.20246C11.422 39.1502 13.2213 36.7297 13.2213 33.744V26.771C13.2213 23.7852 11.422 21.3647 9.20246 21.3647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0843 0H19.9007C17.6812 0 15.8818 2.42045 15.8818 5.40623V12.3792C15.8818 15.365 17.6812 17.7854 19.9007 17.7854H25.0843C27.3039 17.7854 29.1032 15.365 29.1032 12.3792V5.40623C29.1032 2.42045 27.3039 0 25.0843 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0843 21.3647H19.9007C17.6812 21.3647 15.8818 23.7852 15.8818 26.771V33.744C15.8818 36.7297 17.6812 39.1502 19.9007 39.1502H25.0843C27.3039 39.1502 29.1032 36.7297 29.1032 33.744V26.771C29.1032 23.7852 27.3039 21.3647 25.0843 21.3647Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_1417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 39.1502,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvva);
export default __webpack_public_path__ + "static/media/Avva.c7fdca9d47e8f1d213b69cf730fd94ea.svg";
export { ForwardRef as ReactComponent };